import React, { useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import '../forms/quill-overrides.css';

export default function QuillEditor({ value, onChange, showTagsDropdown = true }) {
  const quillRef = useRef(null);

  const insertTag = (tag) => {
    const editor = quillRef.current?.getEditor();
    if (editor) {
      const range = editor.getSelection(true);
      if (range) {
        editor.insertText(range.index, tag + ' ', 'user');
        editor.setSelection(range.index + tag.length + 1);
      }
      setTimeout(() => editor.focus(), 0);
    }
  };

  const baseToolbar = [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean']
  ];

  const tagDropdown = [{ tag: ['#petName', '#petSpecies', '#petBreed', '#petOwnerName', '#clinicName', '#currentDate'] }];

  const modules = {
    toolbar: {
      container: showTagsDropdown ? [...baseToolbar, tagDropdown] : baseToolbar,
      handlers: {
        tag: (value) => {
          if (value) insertTag(value);
        }
      }
    }
  };

  return (
    <div className="quill-wrapper">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
      />
    </div>
  );
}
